'use strict';

angular.module('amexReconciliationApp')
  .component('cycleReceiptsButton', {
    templateUrl: 'scripts/views/components/cycle-receipts-button.html',
    controller: function ($uibModal) {
      var self = this;

      self.openCycleReceiptsModal = function () {
        $uibModal.open({
          template: '<cycle-receipts-modal close-modal-callback="$close()"></cycle-receipts-modal>',
          size: 'lg'
        });
      };
    }
  });


//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/components/cycleReceiptsButton.js
// module id = 445
// module chunks = 0